export default {
  en: {
    title: 'Privacy Policy',
    updated: 'September 11, 2026',
    sections: [
      {
        heading: '1. Overview',
        paragraphs: [
          'This Privacy Policy explains how SocialLabs ("we", "us") collects, uses, and protects personal data when you use our website and application.',
        ],
      },
      {
        heading: '2. Data We Collect',
        paragraphs: [
          'Account data: name, email, password hash, profile settings, subscription status, and API keys you generate.',
          'Usage data: logs, device/browser information, IP address, pages visited, and feature usage for security and improvement.',
          'Content data: designs, uploads, posts, schedules, and messages you store in the Service.',
          'Integration data: OAuth tokens and account metadata from connected services (Google, Meta/Instagram, payment providers).',
          'Payment data: transaction references processed by PayPal or local payment providers; we do not store full card numbers.',
        ],
      },
      {
        heading: '3. How We Use Data',
        paragraphs: [
          'To provide, maintain, and improve the Service.',
          'To authenticate users, process subscriptions, send service-related notices, and prevent abuse.',
          'To publish or schedule content on your behalf when you explicitly request it through connected accounts.',
          'To comply with legal obligations and enforce our Terms.',
        ],
      },
      {
        heading: '4. Legal Bases (where applicable)',
        paragraphs: [
          'We process data based on contract performance (providing the Service), legitimate interests (security, analytics), consent (optional marketing), and legal obligations.',
        ],
      },
      {
        heading: '5. Sharing',
        paragraphs: [
          'We share data with infrastructure providers (hosting, database, email), payment processors, and platform APIs you connect.',
          'We do not sell your personal data. We may disclose data if required by law or to protect rights, safety, and security.',
        ],
      },
      {
        heading: '6. Retention',
        paragraphs: [
          'We retain data while your account is active and as needed for legal, accounting, or security purposes. You may request deletion subject to applicable law and backup cycles.',
        ],
      },
      {
        heading: '7. Security',
        paragraphs: [
          'We use industry-standard measures including encryption in transit, access controls, and secure credential storage. No method of transmission or storage is 100% secure.',
        ],
      },
      {
        heading: '8. Your Rights',
        paragraphs: [
          'Depending on your location, you may request access, correction, deletion, restriction, or portability of your personal data, and withdraw consent where processing is consent-based.',
          'Contact us at contact@codelabs.id to exercise these rights.',
        ],
      },
      {
        heading: '9. International Transfers',
        paragraphs: [
          'Your data may be processed in countries other than your own. We take steps to ensure appropriate safeguards where required.',
        ],
      },
      {
        heading: '10. Children',
        paragraphs: [
          'The Service is not directed to children under 18. We do not knowingly collect data from children.',
        ],
      },
      {
        heading: '11. Changes & Contact',
        paragraphs: [
          'We may update this policy. Material changes will be posted on this page with an updated date.',
          'Privacy questions: contact@codelabs.id',
        ],
      },
    ],
  },
  id: {
    title: 'Kebijakan Privasi',
    updated: '11 September 2026',
    sections: [
      {
        heading: '1. Ringkasan',
        paragraphs: [
          'Kebijakan Privasi ini menjelaskan bagaimana SocialLabs ("kami") mengumpulkan, menggunakan, dan melindungi data pribadi saat Anda menggunakan situs dan aplikasi kami.',
        ],
      },
      {
        heading: '2. Data yang Kami Kumpulkan',
        paragraphs: [
          'Data akun: nama, email, hash password, pengaturan profil, status langganan, dan API key yang Anda buat.',
          'Data penggunaan: log, informasi perangkat/browser, alamat IP, halaman yang dikunjungi, dan penggunaan fitur untuk keamanan dan peningkatan.',
          'Data konten: desain, unggahan, posting, jadwal, dan pesan yang Anda simpan di Layanan.',
          'Data integrasi: token OAuth dan metadata akun dari layanan terhubung (Google, Meta/Instagram, penyedia pembayaran).',
          'Data pembayaran: referensi transaksi yang diproses PayPal atau penyedia pembayaran lokal; kami tidak menyimpan nomor kartu lengkap.',
        ],
      },
      {
        heading: '3. Cara Kami Menggunakan Data',
        paragraphs: [
          'Untuk menyediakan, memelihara, dan meningkatkan Layanan.',
          'Untuk autentikasi, memproses langganan, mengirim pemberitahuan terkait layanan, dan mencegah penyalahgunaan.',
          'Untuk mempublikasikan atau menjadwalkan konten atas permintaan Anda melalui akun terhubung.',
          'Untuk mematuhi kewajiban hukum dan menegakkan Ketentuan kami.',
        ],
      },
      {
        heading: '4. Dasar Hukum (jika berlaku)',
        paragraphs: [
          'Kami memproses data berdasarkan pelaksanaan kontrak (menyediakan Layanan), kepentingan sah (keamanan, analitik), persetujuan (pemasaran opsional), dan kewajiban hukum.',
        ],
      },
      {
        heading: '5. Berbagi Data',
        paragraphs: [
          'Kami membagikan data dengan penyedia infrastruktur (hosting, database, email), pemroses pembayaran, dan API platform yang Anda hubungkan.',
          'Kami tidak menjual data pribadi Anda. Kami dapat mengungkapkan data jika diwajibkan hukum atau untuk melindungi hak, keselamatan, dan keamanan.',
        ],
      },
      {
        heading: '6. Penyimpanan',
        paragraphs: [
          'Kami menyimpan data selama akun aktif dan seperlunya untuk keperluan hukum, akuntansi, atau keamanan. Anda dapat meminta penghapusan sesuai hukum yang berlaku dan siklus cadangan.',
        ],
      },
      {
        heading: '7. Keamanan',
        paragraphs: [
          'Kami menggunakan langkah standar industri termasuk enkripsi saat transmisi, kontrol akses, dan penyimpanan kredensial aman. Tidak ada metode transmisi atau penyimpanan yang 100% aman.',
        ],
      },
      {
        heading: '8. Hak Anda',
        paragraphs: [
          'Tergantung lokasi Anda, Anda dapat meminta akses, koreksi, penghapusan, pembatasan, atau portabilitas data pribadi, serta menarik persetujuan jika pemrosesan berbasis persetujuan.',
          'Hubungi kami di contact@codelabs.id untuk menggunakan hak ini.',
        ],
      },
      {
        heading: '9. Transfer Internasional',
        paragraphs: [
          'Data Anda dapat diproses di negara selain negara Anda. Kami mengambil langkah untuk memastikan perlindungan yang memadai jika diwajibkan.',
        ],
      },
      {
        heading: '10. Anak-anak',
        paragraphs: [
          'Layanan tidak ditujukan untuk anak di bawah 18 tahun. Kami tidak dengan sengaja mengumpulkan data dari anak-anak.',
        ],
      },
      {
        heading: '11. Perubahan & Kontak',
        paragraphs: [
          'Kami dapat memperbarui kebijakan ini. Perubahan material akan diposting di halaman ini dengan tanggal pembaruan.',
          'Pertanyaan privasi: contact@codelabs.id',
        ],
      },
    ],
  },
}
